/**
 * 🔧 Filter Functionality Fix
 * Simple fix for filter checkbox display
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    // Fix filter checkboxes
    fixFilterCheckboxes();
    
    // Fix collection description centering
    fixCollectionDescription();
  });

  /**
   * Fix filter checkboxes display
   */
  function fixFilterCheckboxes() {
    const checkboxes = document.querySelectorAll('.t4s-checkbox-wrapper');
    
    checkboxes.forEach(function(checkbox) {
      // Ensure proper positioning and styling
      checkbox.style.position = 'relative';
      checkbox.style.zIndex = '1';
      checkbox.style.marginRight = '8px';
      checkbox.style.display = 'inline-block';
      checkbox.style.width = '18px';
      checkbox.style.height = '18px';
      checkbox.style.border = '2px solid #cccccc';
      checkbox.style.borderRadius = '3px';
      checkbox.style.backgroundColor = '#ffffff';
      checkbox.style.verticalAlign = 'middle';
      checkbox.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
      
      // Fix SVG icon positioning
      const svg = checkbox.querySelector('svg');
      if (svg) {
        svg.style.position = 'absolute';
        svg.style.top = '50%';
        svg.style.left = '50%';
        svg.style.transform = 'translate(-50%, -50%)';
        svg.style.width = '14px';
        svg.style.height = '14px';
        svg.style.opacity = '0';
        svg.style.transition = 'opacity 0.2s ease';
        svg.style.color = '#f07439';
      }
    });
  }

  /**
   * Fix collection description centering
   */
  function fixCollectionDescription() {
    const collectionDescription = document.querySelector('.collection-description');
    if (collectionDescription) {
      collectionDescription.style.textAlign = 'center';
      collectionDescription.style.maxWidth = '800px';
      collectionDescription.style.margin = '0 auto 20px auto';
      collectionDescription.style.color = '#666666';
      collectionDescription.style.fontSize = '16px';
      collectionDescription.style.lineHeight = '1.6';
    }
  }

  // Run fixes after a short delay to ensure all elements are loaded
  setTimeout(function() {
    fixFilterCheckboxes();
    fixCollectionDescription();
  }, 500);

})(); 